@if (isActive) {
  <div
    data-qa="middle-screen-spinner"
    class="spinner-container flex flex-col items-center justify-center">
    <div class="flex items-center justify-center">
      @switch (currentSpinnerType) {
        @case (SpinnerType.DEFAULT) {
        <svg class="spinner-ring-rounded" viewBox="0 0 50 50">
          <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
        </svg>
        }
      }
    </div>

    <div
      data-qa="spinner-text"
      class="font-2 bold600 {{currentSpinnerType === SpinnerType.DEFAULT ? 'mt-[5rem]' : 'mt-[1rem]'}}">
      {{ spinnerText }}
    </div>
  </div>
}

<!--This spinner has style display none after view init.-->
<!--This #componentSpinner is used for injecting into other components.-->
<!--Key difference, is that it is absolute to its parent,-->
<!--comparing to the spinner on the top, which is shown in the middle of the screen.-->
<div #componentSpinner>
  <div data-qa="component-spinner" id="component-spinner">
    <div class="spinner-container injectable flex flex-row items-center justify-center">
      <div>
        <svg class="spinner-ring-rounded" viewBox="0 0 50 50">
          <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
        </svg>
      </div>
    </div>
  </div>
</div>
